import React from "react";
// import PropTypes from 'prop-types'
import CustomSelect from "../../shared/CustomSelect";
import UploadInput from "../UploadInput";
import { TextField } from "@material-ui/core";
import CustomizedBtn from "../CustomizedBtn";
import { KeyboardTimePicker } from "@material-ui/pickers";

const Formfield = ({
  inputType,
  name,
  value,
  type,
  onChange,
  label,
  options,
  error,
  onClick,
  floatingLabel,
  ...rest
}) => {
  const renderField = () => {
    switch (inputType) {
      case "textfield":
        return (
          <div className="modal-form-formfield">
            {label && <label>{label}</label>}
            <TextField
              name={name}
              value={value}
              label={floatingLabel}
              type={type}
              onChange={onChange}
              fullWidth
              {...rest}
            />
            {error && (
              <span className="modal-form-formfield-error">{error}</span>
            )}
          </div>
        );

      case "uploadImage":
        return (
          <div className="modal-form-formfield">
            {label && <label>{label}</label>}
            <UploadInput
              // error={error}
              value={value}
              onChange={onChange}
              // disabled={disabled}
              {...rest}
            />
            {error && (
              <span className="modal-form-formfield-error">{error}</span>
            )}
          </div>
        );

      case "customSelect":
        return (
          <div className="modal-form-formfield">
            {label && <label>{label}</label>}
            <CustomSelect
              name={name}
              value={value}
              handleChange={onChange}
              noMargin
              options={options}
              {...rest}
            />
            {error && (
              <span className="modal-form-formfield-error">{error}</span>
            )}
          </div>
        );

      case "multiSelect":
        return (
          <div className="modal-form-formfield">
            {label && <label>{label}</label>}
            <CustomSelect
              name={name}
              value={value}
              handleChange={onChange}
              multiple={true}
              noMargin
              options={options}
              {...rest}
            />
            {error && (
              <span className="modal-form-formfield-error">{error}</span>
            )}
          </div>
        );

      case "button":
        return (
          <div className="modal-form-formfield">
            {label && <label>{label}</label>}
            <CustomizedBtn filled={true} margin="0" onClick={onClick} {...rest}>
              {rest.btnTitle}
            </CustomizedBtn>
            {error && (
              <span className="modal-form-formfield-error">{error}</span>
            )}
          </div>
        );

      case "time":
        return (
          <div className="modal-form-formfield">
            {label && <label>{label}</label>}
            <KeyboardTimePicker
              placeholder="08:00 AM"
              mask="__:__ _M"
              label={floatingLabel}
              value={value}
              onChange={onChange}
              fullWidth
              cancelLabel="Cancelar"
              okLabel="Aceptar"
              {...rest}
            />
            {error && (
              <span className="modal-form-formfield-error">{error}</span>
            )}
          </div>
        );

      default:
        return (
          <div className="modal-form-formfield">
            <label>{label}</label>
            <TextField
              name={name}
              value={value}
              type={type}
              fullWidth
              {...rest}
            />
            {error && (
              <span className="modal-form-formfield-error">{error}</span>
            )}
          </div>
        );
    }
  };

  return renderField(inputType);
};

Formfield.propTypes = {};

export default Formfield;
